import { useStore } from "vuex"
import { computed } from "vue"
 
export default {
    name: "DeleteCancerProfileModal",
    props: {
        continueUrl: {
            type: String,
            required: false,
            default: null
        },
        continueUrlWithData: {
            type: String,
            required: false,
            default: null
        }
    },
    setup(props) {
        const store = useStore()
        const cancerforumProfileId = computed(() => store.state.main.page_overlay_content_data.cancerforumProfileId)
        const continueUrl = computed(() => props.continueUrl !== null ?   props.continueUrl : store.state.main.page_overlay_content_data.continueUrl)
        const continueUrlWithData = computed(() => props.continueUrlWithData !== null ?   props.continueUrl : store.state.main.page_overlay_content_data.continueUrlWithData)

        const deleteProfileAndData = () => {
            store.dispatch('forum/deleteCancerProfileAndData', { id: cancerforumProfileId.value, continueUrl: continueUrl.value })
        }
 
        const deleteProfile = () => {
            store.dispatch('forum/deleteCancerProfile', { id: cancerforumProfileId.value, continueUrl: continueUrlWithData.value })
        }  
                       
        return {
            getLabel: (labelKey) => store.getters['labels/getLabel']({labelCollection: 'DeleteCancerProfileModal', labelKey}),
            deleteProfileAndData,
            deleteProfile
        }
    }
}